import React from 'react';
import { HeroSection } from './sections/HeroSection';
import { ProblemSection } from './sections/ProblemSection';
import { SolutionSection } from './sections/SolutionSection';
import { PricingSection } from './sections/PricingSection';
import { TrustSection } from './sections/TrustSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen" style={{
    backgroundColor: '#1F1A17'
  }} data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <PricingSection data-id="element-4" />
      <TrustSection data-id="element-5" />
      <Footer data-id="element-6" />
    </div>;
}